import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import UploadPhotoController from "./upload_photo_controller"
application.register("upload-photo", UploadPhotoController)

import EntryBandController from "./entry_band_controller"
application.register("entry-band", EntryBandController)

import VisionFormController from "./vision_form_controller"
application.register("vision-form", VisionFormController)

import FlashModalController from "./flash_modal_controller"
application.register("flash-modal", FlashModalController)

import PhotoModalController from "./photo_modal_controller"
application.register("photo-modal", PhotoModalController)

import GalleryRowsController from "./gallery_rows_controller"
application.register("gallery-rows", GalleryRowsController)

import WinnerDraftController from "./winner_draft_controller"
application.register("winner-draft", WinnerDraftController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)
